import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {Execution} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {ExecutionStatusBadge} from "../components/ExecutionStatusBadge.tsx";
import {Text} from "@mantine/core";

export const useExecutionsTableColumns = () => {

    const columns: DataTableColumn<Execution>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Execution) => <NavLink to={`/executions/${item.id}`}>{item.name ?? item.id}</NavLink>,
        },
        {
            accessor: 'playbook',
            title: I18n.get('Playbook'),
            width: '1fr',
            render: (item: Execution) => item.playbookId ? (
                <NavLink to={`/playbooks/${item.playbookId}`}>
                    {item.playbook?.displayName ?? item.playbook?.name ?? item.playbookId}
                </NavLink>
            ) : <Text size={'sm'}>n/a</Text>,
        },
        {
            accessor: 'executionStatus',
            title: I18n.get('Status'),
            width: '120px',
            render: (item: Execution) => <ExecutionStatusBadge status={item.executionStatus}/>,
        },
        {
            accessor: 'progress',
            title: I18n.get('Progress'),
            width: '120px',
            render: (item: Execution) => (
                <Text size={'sm'}>
                    {item.completedPhases ?? 0} / {item.totalPhases ?? 0}
                </Text>
            ),
        },
        {
            accessor: 'startedAt',
            title: I18n.get('Started'),
            width: '1fr',
            render: (item: Execution) => item.startedAt ? formatTimestamp(item.startedAt) : <Text size={'sm'}>n/a</Text>,
        },
        {
            accessor: 'createdByUsername',
            title: I18n.get('Started By'),
            width: '1fr',
            render: (item: Execution) => <Text size={'sm'}>{item.createdByUsername ?? 'n/a'}</Text>,
        },
    ];

    return {
        columns,
    };
};
